import WOW from 'wow.js';

const Wow = () => {
  new WOW().init();
};
export default Wow;
